export const LOGIN_URLS = {
    HZ_MYADVANTECH : (current_datacenter: any) => `https://wise-marketplace-member.advantech.com.cn/oauth2/authorize.ashx?response_type=code&client_id=${
        current_datacenter.id
      }&scope=${encodeURIComponent(
        'https://member.advantech.com/user/profile.read https://member.advantech.com/user/email.read',
      )}&redirect_uri=${encodeURIComponent(
        `https://${current_datacenter.catalog}`,
      )}/v4.0/auth/myadvantech/callback`,
    NORMAL_MYADVANTECH : (current_datacenter: any) => `https://member.advantech.com/oauth2/authorize.ashx?response_type=code&client_id=${
        current_datacenter.id
      }&scope=${encodeURIComponent(
        'https://member.advantech.com/user/profile.read https://member.advantech.com/user/email.read',
      )}&redirect_uri=${encodeURIComponent(
        `https://${current_datacenter.catalog}`,
      )}/v4.0/auth/myadvantech/callback`
}